export enum TeacherFeedbackType {
  LIVE_CLASS_FEEDBACK = 'Live Class Feedback',
  ASK_A_TEACHER = 'Ask a Teacher',
  WRITING_FEEDBACK = 'Writing Feedback',
  LEVEL_TEST_FEEDBACK = 'Level Test Feedback',
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-service/teacher-feedback-type.ts